/**
 * @generated SignedSource<<5f87d078387aa078a305cdc703c8ba6a>>
 * @relayHash a1fea2614aa98c05dfb1036827333687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd9b63ad7c104afa5dd2eda315f3e6d628ecf808e109593578057c0699ac6174

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type latestDeploymentForVersionQuery$variables = {
  from: string;
};
export type latestDeploymentForVersionQuery$data = {
  readonly devOps: {
    readonly ariGraph: {
      readonly relationships: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly to: {
              readonly data: {
                readonly lastUpdated?: AGG$DateTime;
                readonly " $fragmentSpreads": FragmentRefs<"deploymentTooltipContent_softwareReleasesLaunchCard_deployment">;
              };
            };
          };
        } | null | undefined>;
      };
    };
  };
};
export type latestDeploymentForVersionQuery = {
  response: latestDeploymentForVersionQuery$data;
  variables: latestDeploymentForVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "from"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": {
      "lastUpdatedSortDirection": "DESC"
    }
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "version-associated-deployment"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "latestDeploymentForVersionQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOps",
          "kind": "LinkedField",
          "name": "devOps",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "AriGraph",
                "kind": "LinkedField",
                "name": "ariGraph",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "args": (v1/*: any*/),
                      "concreteType": "AriGraphRelationshipConnection",
                      "kind": "LinkedField",
                      "name": "relationships",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "AriGraphRelationshipEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "AriGraphRelationship",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "AriGraphRelationshipNode",
                                        "kind": "LinkedField",
                                        "name": "to",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": {
                                              "kind": "LinkedField",
                                              "name": "data",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    {
                                                      "kind": "RequiredField",
                                                      "field": (v2/*: any*/),
                                                      "action": "THROW",
                                                      "path": "devOps.ariGraph.relationships.edges.node.to.data.lastUpdated"
                                                    },
                                                    {
                                                      "kind": "FragmentSpread",
                                                      "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment"
                                                    }
                                                  ],
                                                  "type": "DeploymentSummary"
                                                }
                                              ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.ariGraph.relationships.edges.node.to.data"
                                          }
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "devOps.ariGraph.relationships.edges.node.to"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "devOps.ariGraph.relationships.edges.node"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "devOps.ariGraph.relationships.edges"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "devOps.ariGraph.relationships"
                  }
                ]
              },
              "action": "THROW",
              "path": "devOps.ariGraph"
            }
          ]
        },
        "action": "THROW",
        "path": "devOps"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "latestDeploymentForVersionQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "concreteType": "AriGraph",
            "kind": "LinkedField",
            "name": "ariGraph",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "relationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "state"
                                      },
                                      {
                                        "concreteType": "DevOpsEnvironment",
                                        "kind": "LinkedField",
                                        "name": "environment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "category"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "issueIds"
                                      }
                                    ],
                                    "type": "DeploymentSummary"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "ConfluencePage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "ConfluenceSpace"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsFeatureFlag"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsOperationsComponentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraAutodevJob"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraConfluenceRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraCustomRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraIssueRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "JiraWebRemoteIssueLink"
                                  }
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cd9b63ad7c104afa5dd2eda315f3e6d628ecf808e109593578057c0699ac6174",
    "metadata": {},
    "name": "latestDeploymentForVersionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "804051e6b542c6dc7bf401419bdfe7f9";

export default node;
